import isFeatureEnabled from 'owa-feature-flags/lib/utils/isFeatureEnabled';
import { areFeatureFlagsInitialized } from 'owa-feature-flags/lib/actions/initializeFeatureFlags';

/**
 * Check to if the devTools feature flag is enabled for a user
 */
export const isDevToolsEnabled = () =>
    areFeatureFlagsInitialized() && isFeatureEnabled('fwk-devTools');
